// JS copies of scss variables in App.scss
export const background = "#1e1e1e";
export const sidebarBackground = "#252526";
export const inputBackground = "#252526";
export const border = "#414141";
export const foreground = "#ddd";